import React from 'react';
import PropTypes from 'prop-types';

import {Grid2 as Grid} from 'views/components';
import {CompactCardTable} from 'views/module';

import Card from './Card';

const List = (props) => {
  const data = props.data;
  const isLoading = props.isLoading;
  const loadMore = props.loadMore;
  const hasMore = props.hasMore;
  const onItemUpdate = props.onItemUpdate;
  const hasUnreadMessages = props.hasUnreadMessages;
  const progressWrap = props.statusProgressWrap;
  const admins = props.admins;


  return (
    <Grid container>
      <CompactCardTable
        data={data}
        card={Card}
        cardProps={{
          admins,
          onItemUpdate,
          hasUnreadMessages,
          statusProgressWrap: progressWrap,
        }}
        isLoading={isLoading}
        loadMore={loadMore}
        hasMore={hasMore}
        getItemId={(item) => item.clientRn}
      />
    </Grid>
  );
};
List.propTypes = {
  admins: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  hasMore: PropTypes.bool,
  isLoading: PropTypes.bool,
  loadMore: PropTypes.func,
  onItemUpdate: PropTypes.func,
  hasUnreadMessages: PropTypes.func,
  statusProgressWrap: PropTypes.func.isRequired,
};

export default React.memo(List);
